import React from 'react'

import type { SiteContactData } from '../services/copSiteDetails.service'
import { formatContactName } from './siteDetailsHelpers'

const DEFAULT_EMAIL_LABEL = 'Send E-mail'

type ContactCardProps = {
    contact: SiteContactData
    emailLabel?: string
}

export const ContactCard: React.FC<Readonly<ContactCardProps>> = ({ contact, emailLabel }) => {
    const emailText = emailLabel || DEFAULT_EMAIL_LABEL
    return (
        <div className="contact-card">
            <div>{formatContactName(contact)}</div>
            {contact.role && <div>{contact.role}</div>}
            {contact.phone && (
                <a href={`tel:${contact.phone}`} className="contact-link">
                    Tel. {contact.phone}
                </a>
            )}
            {contact.email && (
                <a href={`mailto:${contact.email}`} className="contact-link">
                    {emailText}
                </a>
            )}
        </div>
    )
}
